import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IProductFilter } from '../../constants/filter/productFilter.constant';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { createSearchParamBySelectedFilterOption } from '../../utils/filter/createSearchParamBySelectedFilterOption.util';
import { useAppSelector } from '../store/useStore';

export const useUpdatePLPSearchParam = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const productFilterStates = useAppSelector((state) => state.filter.productFilter);

  useEffect(() => {
    if (productFilterStates.isSearchParamChecked && productFilterStates.globalFilters) {
      const existingParams = Object.fromEntries(searchParams.entries());

      const newFilterParams = createSearchParamBySelectedFilterOption({
        filterType: 'productFilter',
        filters: productFilterStates.globalFilters as IProductFilter[],
      });

      const mergedParams = {
        ...existingParams,
        ...newFilterParams,
      };

      const newSearchParams = new URLSearchParams(mergedParams).toString();

      navigate(`${pageInfo.productListPage.path}?${newSearchParams}`, {
        replace: true,
      });
    }
  }, [productFilterStates.isSearchParamChecked, productFilterStates.globalFilters]);
};
